var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{scopedSlots:_vm._u([{key:"body",fn:function(ref){
var bodyClass = ref.bodyClass;
return [_c('ShopperSelect',{class:['shopper-select-page', bodyClass, _vm.isMobile ? 'shopper-select-page--mobile' : ''],on:{"profileSwitched":_vm.onProfileSwitch}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }